<template>
    <SideFormSection>
        <template #title> Scheduling Settings </template>
        <template #subtitle>
            Minimum and maximum booking hours in advance, and other settings.
        </template>
        <template #rawContent>
            <Card
                title="Scheduling Settings"
                iconName="calendar"
            >
                <template #content>
                    <div class="space-y-4">
                        <Alert
                            v-if="serviceAggregate.service.isRecurring()"
                            title="NOTE:"
                            type="info"
                        >
                            Recurring meetings don't take into account the
                            "Maximum booking days in advance" setting.
                        </Alert>

                        <ApiForm
                            :url="
                                urlFactory.makeServiceUpdateSchedulingSettingsUrl(
                                    serviceAggregate.service.id,
                                )
                            "
                            method="POST"
                            ref="apiFormRef"
                        >
                            <ServiceSchedulingSettingsForm
                                :service="serviceAggregate.service"
                                :errors="
                                    apiFormRef?.response?.getErrors() ??
                                    new ApiFormErrors({})
                                "
                            />
                        </ApiForm>
                    </div>
                </template>
                <template #actions>
                    <Button
                        @click="apiFormRef?.submit()"
                        :loading="apiFormRef?.loading.valueOf()"
                        iconName="save"
                        color="dark"
                    >
                        Save
                    </Button>
                </template>
            </Card>
        </template>
    </SideFormSection>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { ref, type PropType } from 'vue'
    import SideFormSection from '@/Shared/Component/SideFormSection.vue'
    import Card from '@/Shared/Component/Card.vue'
    import ServiceAggregate from '@/App/Service/Entity/ServiceAggregate'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import Button from '@/Shared/Component/Button.vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import ServiceSchedulingSettingsForm from '@/App/Service/Component/Scheduling/ServiceSchedulingSettingsForm.vue'
    import Alert from '@/Shared/Component/Alert.vue'

    const props = defineProps({
        serviceAggregate: {
            type: Object as PropType<ServiceAggregate>,
            required: true,
        },
    })

    const apiFormRef = ref<ApiFormRefType>(null)
    const urlFactory = new UrlFactory()
</script>
